import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MenuService } from './menu.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { locale } from 'moment';
import { UrlConfigService } from 'app/service/url-config.service';

@Injectable()
export class StartupService {
  //url = environment.SERVER_URL;
  url: string;

  constructor(
    private menuService: MenuService,
    private http: HttpClient,
    private urlConfigService: UrlConfigService
  ) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  data: any = {};
  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.url}home/main-menu-list`, locale)
        .pipe(
          catchError(res => {
            resolve();
            return res;
          })
        )
        .subscribe(
          (res: any) => {
            this.menuService.set(res.menu);
          },
          () => {},
          () => {
            resolve();
          }
        );
    });
  }

  use(lang: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const langPath = `assets/language/${lang || 'en'}.json`;
      this.http
        .get(langPath)
        .pipe(
          catchError(res => {
            resolve();
            return res;
          })
        )
        .subscribe(
          (res: any) => {
            this.data = Object.assign({}, res || {});
            resolve(this.data.json);
          },
          () => {},
          () => {
            resolve();
          }
        );
    });
  }
}
